module.exports = __webpack_public_path__ + "static/media/email_info.d25f4afd.svg";